var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamsterAfraid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_77817)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_152_77817)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.1 308.401C73.9998 308.101 62.8998 310.801 63.3998 313.501C62.4998 321.701 100.9 320.101 108.3 319.701C112.2 319.501 122.6 317.401 124.6 313.701C126.4 310.501 121.2 308.101 117.2 308.301L117.1 308.401Z",
    fill: "#8699A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M238.2 307.8C195.1 307.5 166.5 310.2 167 312.9C166.1 321.1 222 319.4 229.4 319.1C233.3 318.9 243.7 316.8 245.8 313.1C247.6 309.9 242.4 307.5 238.4 307.7L238.2 307.8Z",
    fill: "#8699A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.5 42.5C233.1 46.7 248.5 54.1 252.8 63.9C266.7 95.3 239.5 110.4 240.5 114.7C252.2 165.8 274.9 256.7 238.7 307.1C232.2 316.1 224.9 310.9 226.8 306.7C225 316.7 216.1 313.8 214.3 311.2C212.1 307.9 212.2 317.6 205.3 309.4C185.4 286.1 197.8 282.1 189.2 280.8C159.6 276.4 132.1 279.3 131.9 283.2C131.4 295.3 114.4 307.4 109.5 311C100.3 317.7 98.7999 307.5 100.4 304C103 319.8 84.0999 314.6 89.0999 302.2C90.8999 318.4 82.3999 311.5 78.0999 307.4C56.9999 287.3 57.3999 205.6 85.0999 114.6C87.6999 106.1 62.0999 95.8 75.9999 61.2C80.7999 49.3 89.1999 43.4 97.9999 34.7C132.4 0.400028 161 3.10003 165.4 3.60003C173.6 4.60003 214 9.40003 227.6 41.3C229 44.5 228.2 37.8 228.4 41.9L229.5 42.5Z",
    fill: "url(#paint0_linear_152_77817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5994 285.3C83.7994 281.7 110.099 288.9 126.599 292.4C126.199 301.3 104.599 315.7 102.799 309.3C95.8994 315.3 96.0994 314 90.1994 309.5C78.8994 319 70.3994 295.7 68.3994 285.2H69.5994V285.3Z",
    fill: "#F2908F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.1 295.3C225 286.9 240.8 287.5 248.3 288.5C244.4 286.9 248.6 294.8 248.3 295.1C243.2 303 237.7 312.3 227.7 312.3C228.6 311.9 226.8 309.6 226.6 309.4C223.2 313.9 221.3 311.7 217.8 313.9C216.5 312.6 214.4 311.3 213.7 309.6C205.9 313.2 200.9 306.3 201.3 301.7L198.1 295.3Z",
    fill: "#F2908F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M126.6 12.4004C107.1 32.8004 76.6996 56.6004 87.0996 83.6004C95.0996 104.4 101.6 99.9004 93.8996 127.3C76.3996 189.5 58.1996 294 100.7 313.1C44.9996 328 68.1996 181.8 72.4996 157.4C74.6996 145.2 90.2996 115.9 85.0996 109.8C60.1996 80.3004 77.2996 52.2004 96.2996 38.7004C109.1 29.6004 114.1 15.0004 125.6 11.4004L126.6 12.4004Z",
    fill: "#BC5A28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.9 116.601C236.3 102.701 263.2 101.701 256.4 72.9005C253.4 60.2005 238.3 48.7005 227.3 40.1005C227.1 40.1005 226.9 40.1005 226.7 40.1005C225.6 40.3005 221.6 33.7005 220.4 33.4005C219.6 33.2005 212.1 27.9005 215.6 32.1005C223.8 41.8005 239.3 56.3005 242.8 61.2005C261.7 87.9005 232.3 108.501 235.6 123.401C248.1 181.001 259.9 280.101 227.5 307.601C247.9 315.401 255.4 255.701 256.4 240.401C258.9 204.301 252.1 150.201 240.9 116.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.4 67.4003C172.5 25.4003 149 51.6003 145.8 69.4003C144.8 75.3003 105.5 43.6003 89.2997 59.7003C64.2997 84.6003 115.9 108 121.2 128.2C129.3 159.5 79.8997 184.7 94.4997 242.3C105.4 285.3 205.4 282.1 223.7 257.4C269.3 195.8 201.8 164 210.6 127.7C215 109.5 254.8 84.8003 244.8 67.4003C232.6 46.3003 200.1 66.9003 196.6 64.6003L194.4 67.4003Z",
    fill: "url(#paint1_radial_152_77817)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.3 286.8C129.9 282.3 148 279.6 166.2 279.8C180.2 280 195.2 282.1 207.6 289C208.7 289.6 211.2 288.1 209.8 287.3C197.7 280.5 183.5 278.3 169.8 277.7C150.3 276.9 130.7 279.9 111.8 284.7C110 285.2 110.5 287.2 112.3 286.8Z",
    fill: "#88391E"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.5 40.2007C242.6 50.4007 259.2 68.9007 254.8 89.5007C253.4 95.8007 249.5 100.901 245.2 105.501C243.3 107.601 239.4 110.801 240.1 114.101C243.4 129.301 247.5 144.101 250.1 159.401C252.4 173.201 254 187.101 255 201.001C256.5 223.801 256.2 246.901 252.3 269.401C250.4 280.601 247.5 292.201 241.9 302.101C240 305.501 237.6 308.701 234.3 310.901C233 311.701 231.6 312.201 230 312.201C225 312.101 228.4 307.701 229.6 305.101C228.7 305.201 227.7 305.401 226.8 305.501C225.3 308.801 223.2 315.701 217.9 312.201C214.9 310.201 215.1 304.201 215 301.301C214.1 301.501 213.1 301.801 212.2 302.101C212.5 304.601 212.7 307.001 212.5 309.501C212.3 312.101 211.5 311.501 209.7 310.101C205.5 306.801 201.9 301.901 198.9 297.501C196 293.101 194.2 288.301 193.2 283.101C192.3 278.601 187.1 279.501 183.4 279.001C174.9 277.801 166.3 277.901 157.7 277.801C149.7 277.601 141.2 278.401 133.5 280.801C130.3 281.801 130.7 282.801 129.9 285.701C128.4 291.401 124.8 296.401 120.8 300.601C117.3 304.401 113.1 307.501 108.7 310.401C105.3 312.601 103.2 313.501 101.7 309.401C101 307.601 101.1 305.601 101.8 303.801C100.9 304.001 99.8996 304.201 98.9996 304.401C99.5996 308.401 98.5996 315.601 92.7996 312.301C88.9996 310.201 88.4996 305.501 89.3996 301.701C88.4996 301.901 87.4996 302.101 86.5996 302.301C87.3996 306.201 89.4996 311.601 82.5996 310.801C80.6996 310.601 78.9996 309.101 77.7996 307.801C73.8996 303.701 71.7996 297.701 70.1996 292.401C64.3996 273.901 63.5996 253.601 63.8996 234.401C64.1996 206.601 68.2996 178.901 75.1996 151.901C76.9996 144.901 79.0996 137.901 81.2996 131.001C82.3996 127.501 83.6996 124.001 84.8996 120.501C85.6996 118.401 87.5996 115.201 87.5996 113.001C87.5996 110.301 83.4996 107.201 81.9996 105.301C71.0996 92.3007 71.6996 76.5007 77.8996 61.3007C80.1996 55.6007 83.1996 50.4007 87.4996 46.1007C90.6996 42.9007 94.5996 40.6007 97.9996 37.6007C102.1 33.9007 105.4 29.3007 109.5 25.5007C114.1 21.2007 119.1 17.5007 124.5 14.3007C158.8 -6.09934 205.9 5.30066 225.9 40.3007C226.4 41.1007 229 40.1007 228.7 39.5007C210.1 6.80066 169.1 -4.89934 134.8 8.00066C125.4 11.5007 116.6 17.0007 109.1 23.6007C104.7 27.5007 100.8 31.7007 96.9996 36.1007C93.7996 39.7007 89.3996 42.0007 85.8996 45.3007C72.5996 57.6007 65.6996 81.4007 73.8996 98.2007C76.0996 102.701 79.3996 106.401 82.6996 110.201C83.4996 111.101 84.5996 112.201 84.7996 113.501C85.0996 115.401 82.7996 119.101 82.0996 120.901C80.5996 125.001 79.2996 129.101 77.8996 133.201C69.2996 159.901 64.0996 187.701 61.9996 215.701C60.2996 237.501 60.4996 259.801 64.5996 281.301C65.8996 288.301 67.6996 295.401 70.7996 301.901C72.4996 305.501 74.8996 309.701 78.5996 311.401C81.3996 312.701 84.7996 312.301 87.6996 311.201C92.3996 309.401 90.4996 305.401 89.6996 301.601C89.4996 300.801 86.9996 301.601 86.8996 302.201C85.5996 307.801 87.9996 314.201 94.4996 314.601C100.9 314.901 102.9 309.101 102.1 303.701C102 302.901 99.4996 303.701 99.2996 304.301C97.4996 309.201 100.3 315.801 106.1 313.601C114.5 310.301 122.7 302.601 127.9 295.401C130.5 291.801 132.8 287.401 133.5 283.001C133.8 280.701 139.1 280.701 141 280.401C147.5 279.301 153.9 279.201 160.4 279.301C165.5 279.401 170.6 279.401 175.7 279.801C177.8 280.001 179.8 280.201 181.8 280.501C184 280.801 187.8 280.701 189.7 281.801C190.6 282.401 190.7 284.501 190.9 285.401C191.5 288.301 192.4 291.001 193.6 293.601C195.4 297.501 197.9 300.901 200.6 304.201C203.1 307.301 206.4 312.001 210.5 313.101C216.9 314.801 215.6 304.601 215.2 301.501C215.1 300.801 212.4 301.401 212.4 302.301C212.6 307.301 212.9 314.901 219.5 314.401C225.9 313.901 227.5 310.601 229.7 305.301C230 304.601 227.3 305.001 226.9 305.701C226.2 307.101 222.3 312.201 225.5 313.101C227.3 313.601 229 313.801 230.9 313.501C234.5 313.001 237.6 310.801 240 308.301C248.8 299.101 252.1 284.301 254.5 272.301C258.7 251.301 259.2 229.501 258.3 208.201C257.1 179.401 252.4 150.801 245.4 122.801C244.5 119.301 241.7 114.301 243.5 110.801C244.5 108.801 246.4 107.201 247.9 105.601C252.3 100.801 256.1 95.7007 257.7 89.3007C262.9 68.7007 245.2 49.5007 229.3 39.4007C228.4 38.7007 226 39.9007 226.5 40.2007Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.999 67.6001C176.899 54.0001 162.599 19.6001 136.799 22.1001C112.799 24.3001 106.699 62.7001 130.999 71.2001C137.599 73.5001 146.999 70.6001 153.099 68.1001L152.999 67.6001Z",
    fill: "#E99800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.099 20.6C173.999 19 164.699 54.7 180.899 65.9C203.299 81.4 222.099 61.3999 214.799 39.1C212.099 30.8 206.299 21.2 196.099 22V20.6Z",
    fill: "#E99800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.399 34.7007C241.799 34.8007 238.599 18.7007 236.299 10.4007C234.599 4.10074 223.999 0.200739 217.999 2.80074C211.399 5.70074 201.999 9.10074 205.199 19.2007C205.199 19.4007 222.399 34.7007 222.399 34.7007Z",
    fill: "#D0732E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.3 27.6006C211.9 21.4006 225 6.60059 229 6.60059C230.4 6.60059 233.8 9.10059 235.9 16.5006C239 27.7006 230.6 34.9006 220.3 31.8006L218.3 27.6006Z",
    fill: "#F6B4BA"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.599 32.8004C225.699 33.7004 232.999 33.5004 236.599 27.6004C239.599 22.8004 238.099 16.0004 236.099 11.2004C234.599 7.70039 232.299 4.30039 228.199 6.00039C220.199 9.30039 213.599 19.4004 216.199 27.9004C216.499 28.9004 219.299 28.1004 218.999 27.1004C216.699 19.5004 221.599 12.4004 227.599 8.10039C230.999 5.60039 232.599 10.1004 233.799 13.0004C235.199 16.6004 235.899 20.8004 235.099 24.6004C233.699 31.2004 227.099 31.9004 221.399 31.0004C220.399 31.1004 217.999 32.5004 219.599 32.8004Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.899 35.6006C228.399 35.5006 235.199 34.1006 238.199 27.7006C240.999 21.6006 239.399 11.7006 235.799 6.30057C231.799 0.300574 223.599 0.500574 217.499 2.10057C210.199 4.00057 203.999 8.90057 202.299 16.4006C202.099 17.4006 204.899 17.0006 205.099 16.0006C207.899 4.20057 226.999 -3.49943 234.099 8.80057C236.399 12.8006 236.599 18.0006 236.499 22.5006C236.199 30.7006 230.999 33.9006 223.099 34.1006C221.999 34.1006 219.999 35.7006 221.899 35.6006Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M222.499 11.6006C226.699 14.2006 231.999 22.4006 229.099 27.7006C228.099 29.6006 226.099 32.6006 223.699 32.9006C220.299 33.4006 220.299 30.9006 218.499 28.0006C211.799 24.9006 222.199 10.1006 221.699 11.6006H222.499Z",
    fill: "#E50048"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M203.6 16.1001C205.6 10.4001 212.1 5.00011 217 9.50011C221.1 13.3001 217.4 23.5001 217.6 29.6001C212.9 24.9001 208.2 19.0001 202.6 15.1001L203.6 16.1001Z",
    fill: "#A5221D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.1 4.20015C217.5 5.50015 220.2 6.10015 221.8 7.90015C224.7 5.20015 228.9 5.20015 232.1 6.70015C229.1 2.20015 222.5 2.00015 217.1 3.20015L216.1 4.20015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.999 9.40053C233.799 12.5005 232.799 23.8005 230.299 30.2005C238.599 25.6005 235.199 4.20053 227.999 9.40053H226.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.3 35.8003C82.3001 35.9003 85.8001 18.5003 88.3001 9.50033C90.2001 2.70033 101.6 -1.59967 108.1 1.20033C115.2 4.30033 125.4 8.10033 121.9 19.0003C121.8 19.2003 103.3 35.8003 103.3 35.8003Z",
    fill: "#D0732E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.7 28.1004C114.6 21.4004 100.5 5.40039 96.1003 5.40039C94.6003 5.40039 90.9003 8.10039 88.7003 16.1004C85.3003 28.2004 94.5003 36.0004 105.6 32.6004L107.7 28.1004Z",
    fill: "#F6B4BA"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.6 32.3002C99.3004 33.3002 92.5004 32.5002 89.9004 25.9002C88.2004 21.7002 89.2004 16.6002 90.6004 12.4002C91.2004 10.6002 92.1004 8.80017 93.1004 7.20017C93.5004 6.50017 94.1004 5.90017 94.7004 5.40017C93.8004 5.40017 93.9004 5.50017 95.0004 5.70017C95.7004 6.00017 96.4004 6.40017 97.0004 6.80017C104 11.2002 109.7 19.8002 107.1 28.2002C106.9 28.7002 109.7 28.4002 109.9 27.7002C112.8 18.6002 105.6 7.90017 97.1004 4.50017C93.4004 3.00017 90.4004 7.20017 89.0004 10.0002C86.4004 15.1002 85.2004 21.7002 87.3004 27.1002C90.1004 34.2002 98.8004 34.1002 105 33.2002C106.2 33.2002 107.6 32.0002 105.6 32.3002Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.7 35.1004C96.6001 35.0004 90.2001 33.2004 88.4001 25.6004C87.0001 20.0004 87.8001 12.6004 90.4001 7.30037C93.8001 0.400371 101.6 0.300371 108.1 2.10037C115 4.00037 120.5 8.90037 122.2 16.0004C122.4 17.0004 125.3 16.3004 125 15.2004C121.9 2.10037 100.1 -7.29963 90.0001 4.20037C85.0001 9.80037 84.6001 18.1004 85.3001 25.2004C86.2001 34.3004 94.8001 36.6004 102.6 36.8004C103.7 36.8004 105.6 35.2004 103.7 35.1004Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M103.1 10.7C98.6004 13.6 92.9004 22.4 95.9004 28.1C97.0004 30.2 99.2004 33.4 101.8 33.8C105.5 34.4 105.4 31.7 107.4 28.5C114.7 25.1 103.4 9.1 103.9 10.7H103.1Z",
    fill: "#E50048"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M123.6 15.6999C121.5 9.49991 114.4 3.59991 109.1 8.49991C104.6 12.5999 108.7 23.5999 108.5 30.1999C113.6 25.0999 118.7 18.6999 124.7 14.4999L123.6 15.6999Z",
    fill: "#A5221D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.1 2.70006C108.6 4.10006 105.6 4.80006 103.9 6.70006C100.8 3.80006 96.2002 3.70006 92.7002 5.40006C96.0002 0.60006 103.1 0.30006 108.9 1.60006L110.1 2.70006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4004 6.10059C85.5004 11.4006 87.0004 33.1006 102.1 32.4006C90.4004 29.7006 87.6004 11.1006 99.3004 10.5006C98.7004 7.30059 96.9004 7.50059 94.3004 6.60059L95.4004 6.10059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M210.3 287.501C209.7 298.301 214.7 304.301 219.5 313.201C203 314.601 193.9 292.801 190.6 280.801C196.6 282.301 201.2 287.301 207.4 288.501L210.3 287.501Z",
    fill: "#AA3306"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M113.7 285.601C113.5 292.801 111.2 305.301 106.5 312.101C119.4 308.801 130.2 293.901 131.1 281.301C125 281.601 119.8 284.201 113.7 285.101V285.601Z",
    fill: "#AA3306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.9 137.201C145.7 137.301 118.5 151.001 110.3 176.801C102.7 200.701 119.3 228.501 139.7 235.101C168 244.301 238.4 228.801 222.9 179.101C215.9 156.501 191.6 135.101 169.6 137.301L167.9 137.201Z",
    fill: "url(#paint2_radial_152_77817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3994 298.201C75.9994 303.301 83.1994 314.301 86.4994 305.101C81.0994 305.501 74.7994 301.901 75.8994 296.301L75.3994 298.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7993 304.501C92.0993 307.701 92.3993 309.901 96.1993 310.801C95.4993 308.801 94.5993 305.601 93.2993 303.101L92.7993 304.501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 304.5C103.7 305.8 103.3 306.9 103.6 308.3C109 310 114.7 305.4 116.1 300.2C112.5 303.6 107.4 307.2 102.6 304.5H104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.2 300.601C206.2 302.401 210.1 304.301 210.7 307.401C207.7 307.301 205.4 304.601 204 302.301L205.2 300.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.8 303.2C216.2 307.9 222.9 315.7 223 308.2C219.8 309.4 217.9 306.1 216.8 303.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.3 179.301C249.1 184.501 254.4 188.601 253.1 179.101C253.1 183.201 249 183.301 247 180.301L246.3 179.301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.3 117.6C142.9 110.8 145.8 98.9001 151.6 94.8001C154.8 92.5001 159 92.3001 162.5 90.7001C165.3 89.4001 169.4 85.4001 171.7 87.3001C174.4 89.5001 189.9 94.5001 192.3 97.7001C196.7 103.6 196.1 111.9 193.1 119.1C178.8 108 157.2 112.9 145.9 118.3L146.3 117.6Z",
    fill: "#671500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.9 106.7C162.2 103.7 155.5 103.2 152.2 107.1C151 108.5 150.3 110.3 151 112C151.7 114 154.2 114.5 156.1 114.5C156.8 114.5 158.2 113.3 156.9 113.4C153.6 113.4 151.7 110.9 153.5 108C155.7 104.4 161.3 105.3 164.1 107.6C164.6 107.9 166.4 107.2 165.9 106.7Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.4 108.3C169.7 105.4 172.5 105.5 175.3 107.5C176.8 108.6 178.2 110.4 178.1 112.3C178.1 112.6 180.1 112.4 180.1 111.8C180.3 108.6 176.9 106.2 174.2 105.4C171 104.4 167.6 106.1 165.6 108.5C165.2 109 167.1 108.7 167.4 108.3Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.6 114.5C151.8 112 149.3 109.4 155.1 106C158.5 104.1 163.6 104.7 165.7 107.9C169.8 103.2 180.1 106 178.8 112.3C171.7 112.5 164.6 112.7 155.8 114.6L155.6 114.5Z",
    fill: "#D93442"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.399 91.7006C159.899 94.4006 161.999 100.001 163.599 103.701C167.599 104.401 174.199 105.501 176.299 103.801C180.599 100.201 177.999 95.6006 180.999 91.5006C176.199 90.5006 173.599 88.7006 170.599 86.1006C166.399 90.9006 160.699 91.4006 159.499 91.2006V91.7006H159.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M152.9 94.2002C152.8 104.3 154.4 114.9 176.5 103.9C166.4 105.1 162.4 109.3 159.4 92.2002L152.9 94.2002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.7 91.9006C158.8 93.9006 159.6 96.2006 160.4 98.3006C161 99.9006 161.3 102.301 162.4 103.701C165 107.001 173.5 104.901 176.6 104.401C177.1 104.301 178 104.101 178.2 103.601C179.6 99.6006 180.3 95.5006 182.3 91.7006C182.6 91.2006 179.9 91.4006 179.5 92.2006C177.5 95.9006 176.8 100.101 175.4 104.101C175.9 103.801 176.5 103.601 177 103.301C174.3 103.701 165.5 105.901 164.5 101.601C163.6 98.1006 162.1 94.4006 160.4 91.2006C160.1 90.3006 157.4 91.3006 157.7 91.9006Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.2 103.9C172.9 100.2 172.9 96.4001 173.1 92.7001C173.1 91.4001 170.3 91.9001 170.3 93.0001C170.2 96.8001 170.2 100.5 169.4 104.2C169.1 105.4 172 105 172.2 103.9Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M165.5 119.7C169.6 119.5 174.1 116.3 177.4 119.3C175.1 123.7 165.6 126.1 163.2 121.8L165.5 119.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.9 41.4005C109.1 73.0005 163.7 85.4006 163.2 49.2005C163 38.6005 141.8 20.4005 126.7 40.6005L125.9 41.4005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 41.7008C175.3 49.8008 176.3 55.7008 180.7 63.6008C183.6 67.4008 185.3 65.9008 190.1 67.7008C197.2 70.3008 203.3 67.0008 206 63.9008C214.8 38.9008 187.2 20.4008 178.2 40.0008L177 41.7008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.3 118.5C145.7 108.9 145.1 97.6 155.7 93.5C161.5 91.2 167.8 90.5 172.5 86C171.6 86.2 170.8 86.4 169.9 86.5C173.7 91.5 181 92.2 186.4 94.7C196.7 99.5 194.8 111.3 192.1 120.3C191.9 121.1 194.6 120.7 194.9 119.9C197.5 111.2 199.6 100 190.6 94.4C185 90.9 176.8 91 172.6 85.4C172.1 84.7 170.4 85.5 170 85.9C164.7 91.1 156.5 90.8 150.4 94.6C142.2 99.8 143.3 110.9 144.6 119.1C144.6 120 147.4 119.4 147.3 118.5Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.7 69.3004C141.6 72.4004 129.2 68.2004 125.3 56.9004C122.7 49.4004 125 40.6004 131.5 35.9004C140.4 29.6004 152.9 32.9004 158.4 41.8004C162.7 48.7004 163.7 61.3004 156.3 66.6004C154.8 67.7004 157.1 68.2004 158.1 67.5004C166.5 61.4004 165.5 48.8004 161 40.6004C155.2 30.3004 141.4 28.9004 131.6 33.8004C122.9 38.2004 119.8 48.5004 122.5 57.5004C126.4 70.2004 141.5 73.9004 153.2 70.7004C154.9 70.3004 154.4 68.8004 152.7 69.3004Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.9 64.7008C195.5 68.5008 185 70.2008 179.3 61.3008C175.4 55.2008 175.8 46.5008 178.9 40.2008C183.5 30.6008 195.9 32.4008 202.1 39.6008C208 46.5008 209.7 60.0008 201.9 66.2008C200.4 67.4008 202.7 68.4008 203.8 67.5008C213 60.3008 211 45.7008 204.1 37.6008C197.6 30.0008 184.5 28.8008 178 36.9008C172.6 43.7008 172.5 54.4008 176.4 61.9008C182.2 72.8008 195.8 70.6008 205.2 66.3008C206.9 65.6008 205.3 64.0008 203.9 64.7008Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143 39.4004C128.4 40.0004 120.8 61.5004 141.2 68.1004C152.2 71.6004 159.5 59.9004 159.1 53.1004C158.6 44.3004 148.1 37.7004 142.5 40.7004L143 39.4004Z",
    fill: "#A94116"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.199 40.1003C169.099 52.3003 184.299 72.1003 197.999 65.6003C217.599 56.2003 198.399 28.7003 183.099 41.4003L183.199 40.1003Z",
    fill: "#A94116"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.2 45.3008C135.8 45.9008 130.5 59.8008 143.5 63.6008C150.5 65.7008 155.4 58.1008 155.3 53.7008C155.1 48.1008 148.6 44.0008 144.9 46.1008L145.2 45.3008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.1 43.7002C181 44.3002 175.9 57.9002 188.4 61.7002C195.2 63.7002 199.9 56.3002 199.8 52.0002C199.7 46.5002 193.3 42.5002 189.7 44.5002L190.1 43.7002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.1 41.2001C129.1 43.1001 128 53.6001 137.2 54.2001C142.1 54.6001 144 48.5001 143.2 45.5001C142.1 41.6001 137.1 39.8001 135 41.8001L135.1 41.2001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.9 40.4002C181 37.5002 172.7 51.3002 183.4 52.8002C187.3 53.4002 190.1 53.1002 190.4 50.0002C190.8 45.9002 187.7 40.7002 185.6 40.8002L185.9 40.4002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.1 56.7002C149.1 56.8002 147.5 61.2002 151.7 62.5002C153.9 63.2002 155.4 60.8002 155.4 59.5002C155.3 57.7002 153.2 56.4002 152 57.0002L152.1 56.7002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.9 56.3008C195.5 56.5008 194 59.8008 197.3 60.7008C199.1 61.2008 200.4 59.3008 200.4 58.3008C200.4 57.0008 198.7 56.0008 197.8 56.5008L197.9 56.3008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.4 87.2006C172.7 83.7006 172.3 80.1006 173 76.6006C173.2 75.5006 170.4 76.0006 170.2 76.9006C169.5 80.4006 169.9 84.0006 169.6 87.5006C169.5 88.8006 172.3 88.2006 172.4 87.2006Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.6 26.5002C133.6 24.8002 134.9 23.3002 136.1 22.3002C139.4 19.4002 143.4 21.6002 146.1 24.0002C146.8 24.6002 149.3 23.5002 148.7 23.0002C145.1 19.9002 141 18.8002 136.5 20.5002C133.9 21.5002 130.7 24.2002 130.7 27.3002C130.8 27.9002 133.6 27.4002 133.6 26.5002Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.1 23.9003C188.4 18.2003 196.4 21.8003 198.8 26.3003C199.3 27.2003 202 26.2003 201.6 25.5003C199.5 21.5003 195.9 19.5003 191.4 19.6003C188.3 19.7003 184.2 21.0003 182.5 23.9003C181.9 25.0003 184.7 24.6003 185.1 23.9003Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.3 119.101C151.3 115.401 159.7 114.301 164.9 113.501C174.4 112.101 184.4 114.301 192.4 119.501C193.3 120.101 195.8 118.801 194.6 118.001C185.8 112.201 174.8 110.201 164.5 111.801C158.5 112.701 149.7 114.101 145 118.401C143.7 119.601 146.5 119.801 147.3 119.101Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.9 71.5002C162.2 75.0002 167.7 76.1002 170.2 78.7002C170.8 79.3002 172.4 78.7002 172.8 78.2002C175 75.4002 179 74.2002 181.8 72.2002C183.1 71.3002 180.2 71.3002 179.6 71.8002C176.6 74.0002 172.5 75.2002 170.2 78.2002C171.1 78.0002 171.9 77.8002 172.8 77.7002C170.4 75.2002 164.9 74.2002 163.7 70.9002C163.4 69.8002 160.6 70.6002 160.9 71.5002Z",
    fill: "#9E3022"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M162.101 71.4004C163.401 74.6004 172.201 81.0004 180.201 72.4004C184.501 67.8004 164.001 62.7004 161.801 71.4004H162.101Z",
    fill: "#E50048"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M230.3 72.0004C227.5 65.4004 218.2 65.1004 213.7 70.1004C210 74.3004 209.2 85.6004 209.5 91.0004C210.3 103.5 221.1 117.8 231.4 124.5C233.9 121.2 203.1 65.0004 229.8 74.4004L230.3 72.0004Z",
    fill: "#AA3306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.5 111.001C223.3 106.201 214.3 75.5007 217.2 68.0007C219.4 62.3007 226.7 66.5007 233 64.5007C243.7 61.0007 243.8 68.9007 247.5 74.1007C257.1 87.7007 252.2 124.501 249.7 128.201C237 147.701 226.8 116.001 225.2 107.501L226.5 111.001Z",
    fill: "url(#paint3_linear_152_77817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.201 95.7999C232.401 92.7999 243.001 99.1999 253.601 100.6C253.001 91.9999 248.901 74.5999 244.001 67.4999C239.201 60.5999 218.401 66.3999 217.501 69.4999C216.001 74.3999 214.401 81.4999 215.801 85.6999C217.101 89.5999 219.201 93.1999 219.901 95.9999L221.201 95.7999Z",
    fill: "#F2908F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.001 132.9C248.101 117.4 249.401 112.2 242.901 92.6C241.101 87 230.901 66.3 238.001 64.6C247.001 64 261.201 106.6 247.301 134.1L247.001 132.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227 107.6C221.8 99.1003 217.3 89.9003 217.2 79.7003C217.1 75.2003 218.4 70.9003 220.2 66.9003C221.1 64.8003 224.4 67.4003 225.2 68.1003C227.2 69.8003 228 72.6003 228.5 75.1003C229.4 74.8003 230.4 74.6003 231.3 74.3003C230.5 71.7003 229.7 69.1003 229.6 66.4003C229.5 64.8003 229.3 65.3003 230.1 65.7003C231.5 66.4003 232.7 67.6003 233.9 68.6003C234.3 69.0003 236.9 68.2003 236.6 67.8003C234.6 64.0003 236.8 64.7003 239.5 66.2003C241.1 67.1003 242.2 68.4003 243.2 69.9003C246 74.1003 247.8 78.9003 249.3 83.7003C254.4 100.3 252.9 118.2 246.5 134.2C246.3 134.6 249 134.4 249.3 133.7C256.9 114.7 257.5 93.2003 248.9 74.4003C246.7 69.6003 244.3 65.7003 239.1 63.9003C235.1 62.6003 231.4 64.2003 233.8 68.5003C234.7 68.2003 235.6 67.9003 236.5 67.7003C234.3 65.8003 231.4 63.0003 228.3 64.5003C224.8 66.2003 227.6 72.5003 228.4 75.1003C228.6 75.7003 231.3 74.9003 231.2 74.3003C230.4 69.9003 228.1 65.7003 223.4 65.0003C221.3 64.7003 218.5 65.5003 217.4 67.3003C209.5 80.1003 217.4 97.1003 224.2 108.2C224.5 109 227.1 107.9 227 107.6Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.7 76.0998C240.3 71.1998 236.8 68.1999 233.9 64.8999C233.4 64.2999 230.8 65.2999 231.3 65.8999C234 68.9999 237.6 71.9998 237 76.5998C236.9 77.3998 239.7 76.7998 239.7 76.0998Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.4 77.0004C231.4 75.1004 231.2 73.3004 230.6 71.6004C229.9 69.7004 228.5 68.0004 227.3 66.3004C226.6 65.3004 223.9 66.4004 224.7 67.5004C227 70.7004 228.4 73.2004 228.5 77.3004C228.6 78.7004 231.5 78.2004 231.4 77.0004Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.899 68.5004C223.599 70.5004 224.399 74.0004 226.199 76.7004C228.799 73.0004 225.099 68.3004 220.999 67.9004L220.899 68.5004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.3 67.9002C232.8 70.1002 233.9 73.8002 235.5 76.3002C236.2 72.7002 234 68.7002 230.7 67.2002L231.3 67.9002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M106.7 88.4011C110.7 82.4011 119.9 83.9011 123.4 89.7011C126.3 94.5011 124.9 105.801 123.5 111.001C120.3 123.101 107 135.101 95.6 139.701C93.8 136.001 134.7 86.6011 106.7 90.9011V88.4011Z",
    fill: "#AA3306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.1 127.301C107.2 123.201 121.8 94.8009 120.4 86.9009C119.3 80.8009 111.3 83.6009 105.6 80.4009C95.8003 74.9009 94.2003 82.6009 89.5003 87.1009C77.5003 98.6008 75.3003 135.701 77.0003 139.801C85.8003 161.401 101.8 132.201 105 124.101L103.1 127.301Z",
    fill: "url(#paint4_linear_152_77817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1 113.401C100.7 108.301 89.0004 112.601 78.4004 112.001C80.6004 103.701 87.9004 87.4007 94.2004 81.4007C100.2 75.6007 119.5 85.1007 119.9 88.4007C120.4 93.5007 120.6 100.801 118.5 104.601C116.5 108.201 113.8 111.301 112.5 114.001L111.1 113.401Z",
    fill: "#F2908F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6999 144.901C80.5999 129.501 80.2999 124.201 90.3999 106.101C93.2999 100.901 107.2 82.5009 100.5 79.6009C91.7999 77.3009 69.7999 116.401 78.1999 146.101L78.6999 144.901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.8 124.5C115.1 114.3 123.2 102.2 120.9 87.8005C120.3 83.8005 118.2 82.5005 114.2 83.0005C109.7 83.6005 106.7 87.4005 105.2 91.3005C104.9 92.0005 107.6 91.6005 108 90.9005C108.9 89.1005 113.1 82.8005 110.5 80.9005C108.3 79.2005 103.4 82.5005 101.7 83.4005C102.4 83.5005 103.1 83.6005 103.8 83.6005C108.5 78.0005 101.1 78.4005 97.2999 79.6005C92.6999 81.0005 89.7999 85.1005 87.1999 88.9005C75.5999 105.5 72.3999 126.6 76.1999 146.2C76.2999 147 79.1999 146.3 78.9999 145.4C75.9999 129.6 77.4999 113.5 84.0999 98.8005C86.2999 93.9005 89.0999 89.3005 92.4999 85.1005C93.4999 83.9005 94.4999 82.8005 95.6999 81.8005C98.1999 79.6005 105.2 78.9005 101.3 83.6005C100.6 84.5005 103.1 84.0005 103.4 83.8005C105.5 82.6005 109.2 80.5005 108.2 84.5005C107.6 86.8005 106.3 89.1005 105.2 91.2005C106.1 91.1005 107.1 90.9005 108 90.8005C108.9 88.6005 109.9 86.7005 111.8 85.2005C115.1 82.5005 117.2 84.6005 117.8 87.3005C118.7 91.2005 118.7 95.2005 118 99.2005C116.4 109 109.7 117.4 103.2 124.6C102.5 125.4 105.3 125.1 105.8 124.5Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.4003 90.9013C99.7003 86.3013 103.6 84.1013 106.8 81.6013C107.3 81.2013 107.1 80.8013 106.6 80.7013C105.9 80.6013 105.1 80.8013 104.6 81.2013C101.1 83.9013 96.9003 86.4013 96.6003 91.3013C96.5003 92.4013 99.3003 91.8013 99.4003 90.9013Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.4 93.3009C107.8 91.6009 108.2 90.0009 109.1 88.6009C110.1 87.0009 111.6 85.7009 113 84.5009C114.2 83.3009 111.5 83.1009 110.7 83.9009C109.3 85.2009 107.8 86.6009 106.7 88.2009C105.5 89.8009 105 91.8009 104.6 93.7009C104.3 94.8009 107.2 94.4009 107.4 93.3009Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.6 86.7012C113.6 88.2012 112.1 91.4012 109.9 93.8012C108 89.7012 112.5 85.8012 116.7 86.1012L116.6 86.7012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.5 84.101C104.6 86.001 102.8 89.401 100.8 91.501C100.8 87.801 103.7 84.301 107.3 83.501L106.5 84.101Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_152_77817",
    x1: 343.437,
    y1: 136.373,
    x2: -134.34,
    y2: 204.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00995922,
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    stopColor: "#FDC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2716,
    stopColor: "#F7A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4397,
    stopColor: "#F39200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#F08200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7785,
    stopColor: "#EF7800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9516,
    stopColor: "#EE7402"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_152_77817",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.53 79.8786) scale(239.315 239.316)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0924728,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3111,
    stopColor: "#F8EFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5651,
    stopColor: "#F1E0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#EDD7BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9516,
    stopColor: "#ECD4B5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_152_77817",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.53 143.327) scale(143.351 143.351)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0924728,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3111,
    stopColor: "#F8EFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5651,
    stopColor: "#F1E0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#EDD7BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9516,
    stopColor: "#ECD4B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_152_77817",
    x1: 249.513,
    y1: 79.8228,
    x2: 211.962,
    y2: 122.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00995922,
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    stopColor: "#FDC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2716,
    stopColor: "#F7A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4397,
    stopColor: "#F39200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#F08200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7785,
    stopColor: "#EF7800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9516,
    stopColor: "#EE7402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_152_77817",
    x1: 117.109,
    y1: 116.16,
    x2: 78.5445,
    y2: 111.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00995922,
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    stopColor: "#FDC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2716,
    stopColor: "#F7A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4397,
    stopColor: "#F39200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#F08200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7785,
    stopColor: "#EF7800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9516,
    stopColor: "#EE7402"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_77817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 320,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_152_77817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 197.6,
    height: 321,
    fill: "white",
    transform: "translate(61 -1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamsterAfraid);
export default __webpack_public_path__ + "static/media/hamster_afraid.b11efe1b2bc36e17167c2bbd058d2a93.svg";
export { ForwardRef as ReactComponent };